import {openAppSession} from '@milestoneslabs/milestones-vue-modules/src/core/Helpers/mixpanelAppOpen';

// Anonymous by design: identity is merged later by the main app, after login, from the same
// mixpanel_anonymous_id cookie — so no identify, session replay or autocapture here.
// Every auth page is a full server render; the shared 30-minute window keeps a
// login -> forgot password -> reset journey to a single App Open.
const env = window.env || {};

openAppSession({
    token: env.MIXPANEL_TOKEN,
    anonymousId: env.MIXPANEL_ANONYMOUS_ID,
    apiBaseUrl: `${env.MILESTONES_API_HOST}/${env.MILESTONES_API_PREFIX}/${env.MILESTONES_API_VERSION}`,
    cookieDomain: env.MILESTONES_DOMAIN,
});
